import { useRef } from "react";
import type { Swiper as SwiperInstance } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import "./cases-swiper-block.sass";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { useWidth } from "../../../hooks/use-width";
import iSwiperButton from "../../../assets/icons/swiper-button.svg";
import { getAssetUrl } from "../../../api/api";
import type { TCaseGalleryItem } from "../../../types/types";

type Props = {
  images: TCaseGalleryItem[];
};

function slideMeta(item: TCaseGalleryItem, index: number) {
  if (typeof item === "string") {
    return { src: getAssetUrl(item), reactKey: `slide-${index}` as const };
  }
  return { src: getAssetUrl(item.url), reactKey: item.id };
}

const CasesSwiperBlock = ({ images }: Props) => {
  const swiperRef = useRef<SwiperInstance | null>(null);
  const { isDesktopWidth } = useWidth();

  return (
    <div className="cases-swiper-block">
      <Swiper
        spaceBetween={8}
        slidesPerView="auto"
        navigation
        pagination={{ clickable: true }}
        onSwiper={(swiper: SwiperInstance) => {
          swiperRef.current = swiper;
        }}
      >
        {images &&
          images.map((image, index) => {
            const { src, reactKey } = slideMeta(image, index);
            return (
              <SwiperSlide key={reactKey} style={{ width: "auto" }}>
                <img
                  src={src}
                  className="cases-swiper-block__img"
                  alt=""
                />
              </SwiperSlide>
            );
          })}
      </Swiper>

      {isDesktopWidth && (
        <img
          src={iSwiperButton}
          className="cases-swiper-block__button cases-swiper-block__button-left"
          alt=""
          onClick={() => swiperRef.current?.slidePrev()}
        />
      )}

      {isDesktopWidth && (
        <img
          src={iSwiperButton}
          className="cases-swiper-block__button cases-swiper-block__button-right"
          alt=""
          onClick={() => swiperRef.current?.slideNext()}
        />
      )}
    </div>
  );
};

export default CasesSwiperBlock;
